const BADGE_TITLES = {
  "create_event": "Host",
  "use_invisible_keys": "Ghost",
  "attend_education_events": "Scholar",
  "invite_friends": "Ambassador",
  "use_lockpick": "Lockmaster",
  "map_connections": "People Magnet",
  "get_opened_by_other": "Spotlight",
  "attend_party_events": "Partygoer",
  "attend_recreation_events": "Explorer",
  "attend_sport_events": "Athlete",
  "get_found_by_search": "Sought After",
  "attend_traveling_events": "Wanderer",
  "open_vaults": "Treasure Hunter",
  "use_level4key_on_level1vault": "All Access"
};
const COUNTED_BADGES = new Set([
  'create_event', 'use_invisible_keys', 'attend_education_events', 'invite_friends',
  'use_lockpick', 'map_connections', 'get_opened_by_other', 'attend_party_events',
  'attend_recreation_events', 'attend_sport_events', 'get_found_by_search',
  'attend_traveling_events', 'open_vaults', 'use_level4key_on_level1vault',
]);

export function getQuestBadgeTitle(badge, t) {
  const fallback = BADGE_TITLES[badge?.slug];
  return fallback ? t(`tasks.badge_titles.${badge.slug}`, { defaultValue: fallback }) : badge?.title;
}

export function getQuestBadgeEarnedCondition(badge, t) {
  const count = Number(badge?.required_value);
  if (!Number.isFinite(count) || count <= 0 || !COUNTED_BADGES.has(badge?.slug)) return null;
  return t(`tasks.badge_earned_conditions.${badge.slug}`, { count,
    defaultValue: badge.level_title || t('tasks.badge_requirement', { count }),
  });
}

export function getQuestBadgeDescription(badge, t) {
  return getQuestBadgeEarnedCondition(badge, t) || getQuestBadgeReason(badge, t);
}

export function getQuestBadgeReason(badge, t) {
  if (!COUNTED_BADGES.has(badge?.slug)) return badge?.description || t('tasks.badge_reason_fallback');
  return t(`tasks.badge_reasons.${badge?.slug}`, {
    defaultValue: t('tasks.badge_reason_fallback'),
  });
}
